import { render, staticRenderFns } from "./MatrixReport.vue?vue&type=template&id=1985a6a8&scoped=true"
import script from "./MatrixReport.vue?vue&type=script&lang=js"
export * from "./MatrixReport.vue?vue&type=script&lang=js"
import style0 from "./MatrixReport.vue?vue&type=style&index=0&id=1985a6a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1985a6a8",
  null
  
)

export default component.exports